import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Btn, Cnpj, CustomCheckbox, CustomDataTableHeader, Loading } from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { renderVolumeUnitsCell } from '../ordem-coleta-volume-and-units.helper'
import {
  desassociarDevolucaoParcialOrdemColeta,
  getDevolucaoParcialAssociadas,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'

function DevolucaoParcialAssociada({ ordemColetaId, dispatch }) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [btnDesassociarIsLoading, setBtnDesassociarIsLoading] = useState(false)
  const [devolucoes, setDevolucoes] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  useEffect(() => {
    getDevolucoesParciais()
  }, [])

  // Events
  const onItemClicked = (devolucao, checked) => {
    const index = devolucoes.findIndex(d => d.delivery_id === devolucao.delivery_id)
    if (index !== -1) {
      const d = [...devolucoes]
      d[index].selected = checked
      setDevolucoes(d)
    }
  }

  const onBtnDesassociarClick = async () => {
    try {
      setBtnDesassociarIsLoading(true)
      const devolucoesSelecionadas = devolucoes.filter(d => d.selected)
      const deliveries_ids = devolucoesSelecionadas.map(d => d.delivery_id)
      await desassociarDevolucaoParcialOrdemColeta(deliveries_ids)
      await getDevolucoesParciais()
      dispatch(showMessageBox('Associação Realizada Com Sucesso', null))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setBtnDesassociarIsLoading(false)
    }
  }

  // Helpers
  const getDevolucoesParciais = async () => {
    try {
      const fetchedDevolucoes = await getDevolucaoParcialAssociadas(ordemColetaId)
      setDevolucoes(fetchedDevolucoes)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return isLoading ? (
    <div className="text-center">
      <Loading />
    </div>
  ) : (
    <div>
      <div style={{ marginBottom: 15, marginTop: 10 }}>
        <Btn isLoading={btnDesassociarIsLoading} onClick={onBtnDesassociarClick}>
          Desassociar
        </Btn>
      </div>
      <DataTable
        paginator={true}
        rows={5}
        value={devolucoes}
        header={<CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />}
        globalFilter={globalFilter}
        emptyMessage="Não existe Devoluções Parciais Associadas"
      >
        <Column
          header=""
          style={tableCellCentered(80)}
          body={devolucao => (
            <CustomCheckbox
              checked={devolucao.selected}
              onChange={value => onItemClicked(devolucao, value)}
            />
          )}
        />
        <Column field="identifier" header="Identificador" style={tableCellCentered(120)} />
        <Column field="invoice_number_entrega" header="NF Entrega" style={tableCellCentered()} />
        <Column field="razao_social" header="Razão" />
        <Column
          field="cnpj"
          header="CNPJ"
          style={tableCellCentered(170)}
          body={devolucao => <Cnpj>{devolucao.cnpj}</Cnpj>}
        />
        <Column field="city" header="Cidade" />
        <Column field="district" header="Bairro" />
        <Column
          field="qte_sku"
          header="Qte. Faltas"
          style={tableCellCentered(110)}
          body={dev => renderVolumeUnitsCell(dev.qte_sku_vol, dev.qte_sku_uni)}
        />
      </DataTable>
    </div>
  )
}

export default connect()(withRouter(DevolucaoParcialAssociada))
